
import { Base } from "./Base";
import { IBase, ILocation, ISize, IPerson, IFile, IMessage, 
         EMessageType, ENotificationType, 
         IContact, ITeam, ETeamType, EContactStatus, 
         IChannel, EChannelType, Image, 
         IPostProperties, IUserProperties, IFileProperties
} from "./shared/types";

import i18n, 
       { transformDateRecent, transformDateFormatted } 
from "@/common/filters";

import { User } from "./User";
import { Message } from "./Message";
import { Contact } from "./Contact";

import { isString, createDate } from "@/common/utils";

const TIME_OUT = 0;
const TIME_INTERVAL = 5;
const MAX_TRIES = 500;
const GOOGLE_STATIC_MAP_URL = 'https://maps.googleapis.com/maps/api/staticmap?zoom=15&maptype=roadmap&format=png&scale=1';

export class Channel extends Base implements IChannel {
  HalloId: string;
  Code: string;
  Name: string;
  Catchword: string;
  Avatar: string = '~/images/hallo.user.png';
  CoverImage:string = '~/images/user.cover.jpg';
  QRCode: string;
  
  Type: EChannelType;
  Team: ITeam; //contact to whom this channel belongs
  Contacts: Contact[] = [];
  Messages: Message[] = [];
  LastMessage?: Message;
  Unread: number; //total number of messages having Read==0

  ListIndex?: number; //for display in list view purpose

  protected _propertyNames = [
    'HalloId', 'Code', 'Name', 'Catchword', 'Avatar', 'CoverImage', 'QRCode', 
    'Type', 'Team', 'Contacts', 'Messages', 'LastMessage', 'Unread'
  ];

  constructor(channel?:IChannel) {
    super();
    if (channel) {
      this.Properties = channel;
    }
  }

  get Propertis() : IChannel {
    return <IChannel>this.getProperties();
  }

  set Properties(channel:IChannel) {
    for (let p in channel) {
      if (p=='Team') {
        this[p] = channel[p];
      } else if (p=='Contacts') {
        this[p] = channel[p].map((contact) => {
          return new Contact(contact);
        }, this);
      } else if (p=='Messages') {
        channel[p].forEach((message) => {
          this[p].push(new Message(message));
        }, this);
      } else if (this._propertyNames.indexOf(p) != -1) {
        this[p] = channel[p];
      }
    }
  }

  set PropertiesFromStorage(data) {
    if (!(data && data.channel_id)) {
      return;
    }
    if (data.channel_id!=this.HalloId) {
      this.HalloId = data.channel_id;
    }

    let p;
    let mapping = {
      channel_id: 'HalloId',
      channel_code: 'Code',
      channel_name: 'Name',
      channel_catchword: 'Catchword',
      unread_messages: 'Unread'
    }
    for (p in mapping) {
      if (data[p] && data[p]!=this[mapping[p]]) {
        this[mapping[p]] = data[p];
      }
    }
    if (data.channel_type=='O' && this.Type!=EChannelType.Public) {
      this.Type = EChannelType.Public;
    } else if (data.channel_type=='D' && this.Type!=EChannelType.Direct) {
      this.Type = EChannelType.Direct;
    } else if (data.channel_type=='G' && this.Type!=EChannelType.Group) {
      this.Type = EChannelType.Group;
    } else if (data.channel_type=='P' && this.Type!=EChannelType.Private) {
      this.Type = EChannelType.Private;
    }
    if (data.channel_members) {
      this.Contacts = [];
      data.channel_members.forEach((m) => {
        let c:Contact = new Contact();
        c.PropertiesFromStorage = m;
        this.Contacts.push(c);
      });
    }
    //total_messages,channel_team_id, and channel_owner {}
  }

  private _loadingAvatar: boolean = true;
  get LoadingAvatar() : boolean {
    return this._loadingAvatar;
  }
  
  onAvatarLoaded(args) {
    setTimeout(() => {
      this._loadingAvatar = false;
    },200);
  }

  async fetchMessages(isUp?:boolean) : Promise<Message[]> {
    try {
      // to do user.requestResources()
      let messages:Message[] = [];
      return messages;
    } catch {
    }
  }

  get AvatarURL() : string {
    return this.Avatar;
  }

  get ChannelType() : string {
    return i18n.L('channelType' + EChannelType[this.Type]);
  }

  get isSingleContact() : boolean {
    return this.Contacts && this.Contacts.length==2;
  }

  get UnreadMessageCount() : string {
    return (this.Unread>=100) ? '' : this.Unread + '';
  }

  get LastMessageText() : string {
    if (!this.LastMessage) {
      return null;
    }
    let m = this.LastMessage;
    let s:string = '';
    s  = (m.Sender.HalloId==this.Team.HalloId) ? i18n.L('you') : m.Sender.Name;
    s += ': ';

    if (m.Type == EMessageType.Text) {
      s += m.Text;
    } else {
      s += i18n.L(['sent',('messageType'+EMessageType[m.Type]),'toYou']);
    }
    return s;
  }

  get LastMessageDateSentRecent() : string {
    return this.LastMessage ? transformDateRecent(this.LastMessage.DateSent, 'yy-MMM') : null;
  }

  getSender(HalloId:string) : Contact {
    let sender:Contact;
    //if (this.Type==EChannelType.Direct) {
    //    sender = this.Team.Members[0];
    //} else {
      for (let i=0; i<this.Contacts.length; i++) {
        if (this.Contacts[i].HalloId==HalloId) {
          sender = this.Contacts[i];
          break;
        }
      }
    //}
    return sender;
  }
}